module.exports = __webpack_public_path__ + "img/logo4.434dc882.png";